import React from "react";

/**
 * @component BellOffIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <BellOffIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BellOffIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="BellOffIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M11 19c0 .6.4 1 1 1s1-.4 1-1h2c0 1.7-1.3 3-3 3s-3-1.3-3-3h2zM4.222 2.808l16.97 16.97-1.414 1.414L16.586 18H3v-3.9l.7-.2C4.5 13.6 5 12.8 5 12v-2c0-1.029.232-2.028.652-2.932L2.808 4.222l1.414-1.414zM12 1c1.44 0 2.696 1.014 2.97 2.51l.03.19c2.4 1.2 4 3.6 4 6.3v2c0 .8.5 1.6 1.3 1.9l.7.2v2.674l-3.909-3.907A4.121 4.121 0 0117 12v-2c0-1.9-1.1-3.7-2.9-4.5l-1-.5-.1-1.1c-.1-.5-.5-.9-1-.9s-.9.4-1 .9L10.9 5l-1 .5-.118.055-1.481-1.482c.224-.137.458-.262.699-.373.2-1.6 1.5-2.7 3-2.7zm2.586 15L7.198 8.613C7.068 9.06 7 9.527 7 10v2c0 1.4-.8 2.8-2 3.5v.5h9.586z"
        fillRule="evenodd"
      />
    </svg>
  )
);
BellOffIcon.displayName = "BellOffIcon";
export default BellOffIcon;
